/**
 * A utility function to identify whether the lenderUser is on a mobile device
 */

export const isMobileDevice = () => {
    const mobileRegex = new RegExp('Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini', 'i');
    return mobileRegex.test(navigator.userAgent);
};
